import {DumpsterFire} from "../DumpsterFire";
import {DumpsterFireGameMode} from "../server/DumpsterFireGameMode";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {DumpsterFireGameAssets} from "../DumpsterFireGameAssets";
import {gsap, TimelineLite} from "gsap";
import {IWinRatioConfig} from "../server/DumpsterFireData";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";

export class DFTotalWinView extends PIXI.Container implements StageLayer {

    public isPlayedCountUpEnds: boolean = false;
    private _totalWinCountUp: BasicBitmapCountUp;
    private _totalWinAmount: number;
    private _endSound: boolean = true;
    private _playSound: boolean = true;
    private _mainTl: TimelineLite;

    constructor() {
        super();
        this.name = "SSTotalWinView";
        this.init();
    }

    public playShotAnim(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline(),
            winNumber: number = DumpsterFire.model.gameData.accumulatedRoundWin,
            isNoWin: boolean = (winNumber === 0.00);

        return tl;
    }

    public getTotalWinTimeline(totalWin: number): TimelineLite {
        this.isPlayedCountUpEnds = false;
        this._mainTl = new TimelineLite();
        if (this._mainTl && this._mainTl.isActive()) {
            this._mainTl.pause();
            this._mainTl.kill();
        }
        this._endSound = false;
        this._totalWinAmount = totalWin;
        this._playSound = true;
        if ((DumpsterFire.model.data.mode === DumpsterFireGameMode.FREESPIN || DumpsterFire.model.data.mode === DumpsterFireGameMode.FREESPIN_SUPER) && this._totalWinAmount === 0) {
            return this._mainTl;
        }
        if (DumpsterFire.isWinBelowStake()) {
            this._playSound = false;
            this._totalWinCountUp.visible = false;
            return this._mainTl;
        }
        const winRatioConfig: IWinRatioConfig = DumpsterFire.model.winRatioConfig;
        this._mainTl.add(() => {
            this._totalWinCountUp.visible = true;
        }, 0);
        const countAnim = new TimelineSprite(DumpsterFire.assetLoader.getTextures("countUp_upgrade/countUp_upgrade_"));
        countAnim.anchor.set(0.5);
        countAnim.scale.set(2);
        countAnim.position.set(360, 410);
        countAnim.visible = false;
        this.addChild(countAnim);
        if (winRatioConfig.duration === 0) {
            this._mainTl.add(this._totalWinCountUp.getCountAnimation(totalWin, totalWin, winRatioConfig.duration));
            this._mainTl.add(() => {
                this._totalWinCountUp.alpha = 1;
                this._endSound = false;
                DumpsterFire.soundPlayer.stopCountUp();
            }, 0);
        } else {
            this._mainTl.add(() => {
                DumpsterFire.soundPlayer.startCountUp();
            }, 0);
            this._totalWinCountUp.alpha = 0;
            this._mainTl.to(this._totalWinCountUp, {
                duration: 0.2,
                alpha: 1,
                ease: "power3.out"
            }, 0);
            this._mainTl.add(this._totalWinCountUp.getCountAnimation(0, totalWin, winRatioConfig.duration), 0);
            this._mainTl.add([() => {
                this._totalWinCountUp.stopAt(totalWin);
                this._endSound = false;
                DumpsterFire.soundPlayer.stopCountUp();
                countAnim.visible = true;
                countAnim.getAnimationAutoShowHide();
            }]);
        }
        DumpsterFire.keypadPlugin.setWin(DumpsterFire.model.gameData.accumulatedRoundWin, true, DumpsterFire.isWinBelowStake());
        this._mainTl.to(this._totalWinCountUp, {
            duration: 0.1,
            alpha: 0,
            ease: "power3.out"
        }, "+=1.2");

        this._mainTl.add(() => {
            this._totalWinCountUp.visible = false;
            this._totalWinCountUp.alpha = 1;
        });

        return this._mainTl;
    }

    public hardAbort(): void {
        if (this._mainTl) {
            const winRatioConfig: IWinRatioConfig = DumpsterFire.model.winRatioConfig;
            this._mainTl.pause();
            this._mainTl.kill();
            DumpsterFire.keypadPlugin.setWin(DumpsterFire.model.gameData.accumulatedRoundWin, true, DumpsterFire.isWinBelowStake());
            this._totalWinCountUp.alpha = 1;
            this._totalWinCountUp.position.set(360);
            if (winRatioConfig.duration !== 0) {
                this._totalWinCountUp.visible = true;
                this._totalWinCountUp.stopAt(this._totalWinAmount);
            }
            this.fadeOutWinPres(0.2, 0.3);
            if (this._playSound && !this._endSound) {
                this._endSound = true;
                DumpsterFire.soundPlayer.stopCountUp();
            }
        }
    }

    private fadeOutWinPres(duration: number, delay: number): void {
        const tl: TimelineLite = new TimelineLite({
            delay: delay
        });
        tl.to(this._totalWinCountUp, {
            duration: duration,
            alpha: 0,
            ease: "power3.out"
        });
        tl.add(() => {
            this._totalWinCountUp.visible = false;
        });
    }

    private init(): void {
        this._totalWinCountUp = new BasicBitmapCountUp({
            fontName: DumpsterFireGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 59,
        }, 420, new PIXI.Point(0.5, 0.5));
        this._totalWinCountUp.position.set(360);
        this._totalWinCountUp.visible = false;
        this.addChild(this._totalWinCountUp);

        if (DumpsterFire.model.isRestore) {
            DumpsterFire.keypadPlugin.setWin(DumpsterFire.model.initData.accumulatedRoundWin, true, DumpsterFire.isWinBelowStake());
        }
    }
}